import { QuestionnaireSchema } from '@breathelife/types';
import ApiService from './ApiService';

export async function getQuestionnaireSchema(questionnaireVersionId: string): Promise<QuestionnaireSchema> {
  const response = await ApiService.admin.getQuestionnaireSchema(questionnaireVersionId);
  return response.data;
}
